/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AccessTokenToastWarningTimeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ACCESS_TOKEN_TOAST_WARNING_TIME')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class AccessTokenToastWarningTimeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AccessTokenToastWarningTimeSettingParser.decode(input).map(res => new AccessTokenToastWarningTimeSetting(res));
    }
    static unsafeDecode(input) {
        return AccessTokenToastWarningTimeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AccessTokenToastWarningTimeSettingParser.encode(data);
    }
    static schema() {
        return AccessTokenToastWarningTimeSettingParser.schema();
    }
}
